import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("admin_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const imgUrl = (p) => (!p ? "" : p.startsWith("http") ? p : `${API}/files/${p}`);

export const eur = (n) =>
  new Intl.NumberFormat("lt-LT", { style: "currency", currency: "EUR" }).format(n || 0);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Error";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return String(d);
}

export function visitorId() {
  let v = localStorage.getItem("visitor_id");
  if (!v) {
    v = (crypto.randomUUID && crypto.randomUUID()) || String(Date.now() + Math.random());
    localStorage.setItem("visitor_id", v);
  }
  return v;
}
